export default (property: string, value: any, transform?: (x: any) => any) => {
    return value || value === 0 ? `${property}: ${transform ? transform(value) : value};` : null;
};
